import React, { forwardRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: SelectOption[];
  placeholder?: string;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  options,
  placeholder,
  className = '',
  id,
  ...props
}, ref) => {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-335">
        {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-300 mb-1.5" data-id="element-336">
            {label}
          </label>}
        <div className="relative" data-id="element-337">
          <select ref={ref} id={selectId} className={`
              w-full px-4 py-2.5 pr-10 rounded-xl border bg-[#1a1a1a] appearance-none
              text-white transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
              disabled:bg-[#0a0a0a] disabled:text-gray-600 disabled:cursor-not-allowed
              ${error ? 'border-red-500 focus:ring-red-500' : 'border-[#2a2a2a] hover:border-[#333333]'}
              ${className}
            `} {...props} data-id="element-338">
            {placeholder && <option value="" disabled data-id="element-339">
                {placeholder}
              </option>}
            {options.map(option => <option key={option.value} value={option.value} data-id="element-340">
                {option.label}
              </option>)}
          </select>
          <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500 pointer-events-none" data-id="element-341" />
        </div>
        {error && <p className="mt-1.5 text-sm text-red-400" data-id="element-342">{error}</p>}
      </div>;
});
Select.displayName = 'Select';